import { Article } from '@/api/articles';
import Link from '../Link';
import Image from 'next/image';
import { withLeadingZero } from '@/utils/strings';

const ArticleItem = ({
    slug,
    name,
    signature,
    published_at,
    description,
    preview_image,
    tags,
    variant = 'default',
}: Article & { variant?: 'default' | 'list-item' }) => {
    const date = new Date(published_at * 1000);
    const day = withLeadingZero(date.getDate());
    const month = withLeadingZero(date.getMonth() + 1);
    const year = date.getFullYear();

    return (
        <Link href={`/blog/${slug}`} className="article-item">
            {preview_image && (
                <div className="article-item-bg">
                    <Image
                        className="article-item-img"
                        src={preview_image.src}
                        width={preview_image.width}
                        height={preview_image.height}
                        alt={`Превью статьи ${name}`}
                    />
                </div>
            )}
            <div className="article-item__inner">
                <div className="article-item__header">
                    <ul className="article-item__tags list-unstyled">
                        {tags.map((item, i) => {
                            return <li className="m-text-xs" key={i}>{`[ ${item.name} ]`}</li>;
                        })}
                    </ul>

                    <div className="article-item__info m-text-xs">
                        <div className="article-item__sign">{signature}</div>
                        <div className="article-item__date">/ {`${day}.${month}.${year}`}</div>
                    </div>
                </div>

                <div className="article-item__footer">
                    {variant === 'default' && (
                        <>
                            <div className="article-item__title h1">{name}</div>
                            {description && <div className="article-item__description text-l">{description}</div>}
                        </>
                    )}
                    {variant === 'list-item' && (
                        <>
                            <div className="article-item__title h2">{name}</div>
                        </>
                    )}
                </div>
            </div>
        </Link>
    );
};

export default ArticleItem;
